export default function Testimonials() {
  const secondaryReviews = [
    {
      name: 'John Davis',
      location: 'Norman, OK',
      avatar: 'JD',
      rating: 5,
      text: 'Excellent service from start to finish. They made the insurance process so easy and our new roof looks amazing!'
    },
    {
      name: 'Emily Rodriguez',
      location: 'Moore, OK',
      avatar: 'ER',
      rating: 5,
      text: 'Professional crew, quality work, and great communication. Highly recommend Good Pitch Roofing to anyone needing roof work.'
    }
  ];

  return (
    <section id="testimonials" className="bg-[#F0F4F8] py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Featured Review Card */}
          <div className="lg:w-3/5">
            <div className="relative bg-[#1A1A1A] rounded-[40px] p-12 lg:p-16 h-full min-h-[480px] flex flex-col justify-between">
              {/* Decorative Quote */}
              <div className="text-[#F5E6D3] text-8xl font-serif leading-none mb-6">"</div>

              {/* Review Text */}
              <div className="flex-1">
                <p className="text-white text-3xl font-light leading-relaxed mb-12">
                  Good Pitch Roofing handled our insurance claim perfectly. After the hail storm, they had our new roof installed in just two weeks. Professional and stress-free!
                </p>
              </div>

              {/* Signature */}
              <div className="space-y-3 mb-8">
                <div className="text-white text-xl font-bold">Sarah Mitchell</div>
                <div className="text-gray-400 text-base">Edmond, OK Homeowner</div>
              </div>

              {/* CTA Button */}
              <div>
                <button className="bg-[#FFB4A2] text-[#1B2838] px-8 py-3 rounded-full font-semibold hover:bg-[#ff9f8a] transition-colors whitespace-nowrap cursor-pointer">
                  Read More Reviews
                </button>
              </div>

              {/* Portrait Image Overlay */}
              <div className="hidden lg:block absolute -left-8 top-1/2 transform -translate-y-1/2 w-72 h-96 rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/d6bb94e4275603f04937b3880c53a518.jpg"
                  alt="Sarah Mitchell"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Secondary Reviews Stack */}
          <div className="lg:w-2/5 flex flex-col gap-8">
            {secondaryReviews.map((review, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow"
              >
                <div className="flex items-start gap-4">
                  {/* Avatar */}
                  <div className="w-16 h-16 rounded-full bg-[#FF6B35] flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">{review.avatar}</span>
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    {/* Stars */}
                    <div className="flex gap-1 mb-3">
                      {[...Array(review.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-500 text-base"></i>
                      ))}
                    </div>

                    {/* Review Text */}
                    <p className="text-gray-700 text-sm leading-relaxed mb-3">
                      {review.text}
                    </p>

                    {/* Name & Location */}
                    <div>
                      <div className="text-[#1B2838] font-bold text-sm">{review.name}</div>
                      <div className="text-gray-500 text-xs">{review.location}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}